import { render, staticRenderFns } from "./ArticleProperties.vue?vue&type=template&id=95806708&"
import script from "./ArticleProperties.vue?vue&type=script&lang=js&"
export * from "./ArticleProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports